<template>
  <base-modal overlay-class="mini_games_modal" modal-content-class="modal modal__content mini_games_modal">
    <div class="modal__body">
      <template v-if="successful">
        <h1>{{ getTranslations.modal_post_game_lantern_success_title }}</h1>
        <p>{{ getTranslations.modal_post_game_lantern_success_subtitle }}</p>
      </template>

      <template v-else>
        <h1>{{ getTranslations.modal_post_game_lantern_failed_title }}</h1>
        <p>{{ getTranslations.modal_post_game_lantern_failed_subtitle }}</p>
      </template>

      <base-image src="/static/images/lanterns/lantern_sign.svg" image-class="modal_icon_main" alt="lantern icon" />
    </div>

    <div class="modal__footer">
      <template v-if="successful">
        <p>{{ getTranslations.modal_post_game_lantern_success_you_earned }}</p>
        <div class="reward_points">+{{ prizeValue }} {{ getTranslations.modal_post_game_lantern_success_reward }}</div>
      </template>

      <template v-else>
        <p>
          {{ getTranslations.modal_post_game_lantern_failed_description_pt1 }}<br>
          {{ getTranslations.modal_post_game_lantern_failed_description_pt2 }}
        </p>
      </template>

      <base-button
        container-default-class=""
        container-class="ti_btn--main"
        button-class="fancy_btn close_modal"
      >
        {{ getTranslations.modal_post_game_lantern_button_proceed }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseModal from '../../../../common/modal/BaseModal.vue';
import BaseImage from '../../../../common/image/BaseImage.vue';
import BaseButton from '../../../../common/button/BaseButton.vue';

export default {
  name: 'PostGameLanternModal',
  components: {
    BaseModal,
    BaseImage,
    BaseButton,
  },
  props: {
    score: {
      type: Number,
      default: 0,
    },
    prizeValue: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    successful () {
      return this.score > 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addOnGame/components/PostGameLanternModal.vue